import { Link } from 'react-router-dom';
import instrumentsImage from '@/assets/images/instruments.webp';
import { ArrowRight } from '@/components/icons';
import { Button } from '@/components/ui/button';
import { HeroSlideLayout } from './HeroSlideLayout';

/**
 * The SATEPSI catalog has no route of its own — it only opens as the "Adicionar
 * Instrumentos" modal from an existing Tabela block inside the editor. This article is
 * the only navigable page that explains it. (`/assets` is a different catalog entirely:
 * public-domain screeners the patient answers by link. Both are called *instrumentos* in
 * the copy — the split is where they live, not what they are named.)
 */
const ADD_TABLE_ARTICLE_URL = '/help/reports/resultados-dos-testes';

export const CatalogSlide = () => {
    return (
        <HeroSlideLayout
            // "Centenas", not a hard number: the count is runtime pagination data, and the
            // help center already words it this way.
            title="Centenas de instrumentos do SATEPSI"
            description="Escolha o instrumento e a tabela entra no laudo já formatada. Ou importe o PDF da editora e nós extraímos os resultados."
            action={
                <Link to={ADD_TABLE_ARTICLE_URL} className="block">
                    <Button size="lg" variant="outline" className="w-full sm:w-auto">
                        Como adicionar ao laudo
                        <ArrowRight className="size-4" />
                    </Button>
                </Link>
            }
            // Centered so the column clears the carousel dots, as on PrivacySlide.
            // xl-only: the artwork is too wide to share the card with this slide's
            // two-line description at lg (lg:hidden overrides the wrapper's lg:flex).
            asideClassName="inset-y-0 right-6 items-center lg:hidden xl:flex xl:right-10"
            aside={
                <img
                    src={instrumentsImage}
                    alt=""
                    // Intrinsic size, so the browser reserves the box instead of reflowing on load.
                    width={668}
                    height={209}
                    // The carousel keeps every slide mounted but translated off-viewport, so this
                    // defers the download until the user actually reaches this slide.
                    loading="lazy"
                    decoding="async"
                    className="h-36 w-auto object-contain"
                />
            }
        />
    );
};
